import { type ISmartCallFlowAction } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/type.ts'

export const getAllChildActionsById = ({
  id,
  getActionById,
}: {
  id: string
  getActionById: (id: string) => ISmartCallFlowAction | undefined
}) => {
  const actions: ISmartCallFlowAction[] = []
  const findAction = (id: string) => {
    const action = getActionById(id)
    if (!action) return
    actions.push(action)
    action.actionStore.nextIds.forEach(findAction)
  }
  findAction(id)
  return actions
}
